/**
 * @generated SignedSource<<9d263429defb5edecdbfffa9f9b67f5e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GLOBAL_FILTER_CONTEXT = "PROJECTS" | "PEOPLE" | "TASKS" | "TIME_REGS" | "INVOICES" | "SKILLS" | "LABELS" | "PLACEHOLDERS" | "RESOURCES" | "%future added value";
export type GLOBAL_FILTER_FIELD = "AUDIT_ACTOR" | "AUDIT_ACTOR_SOURCE" | "AUDIT_APPROVAL_TYPE" | "AUDIT_BATCH_ID" | "AUDIT_EVENT_DATE" | "AUDIT_EVENT_TYPE" | "AUDIT_FIELD_NAME" | "AUDIT_FROM_STATUS" | "AUDIT_IS_MATERIAL" | "AUDIT_TIME_TYPE" | "AUDIT_TO_STATUS" | "AUDIT_WORK_DATE" | "COMPANY_TASK_ID" | "NAME" | "STATUS" | "PROJECT_STATUS" | "PROJECT_GROUP_STATUS" | "PROJECT_PHASE" | "PROJECT_SPRINT" | "PROJECT_GROUP_SPRINT" | "DESCRIPTION" | "REMAINING" | "TIME_REGS" | "FORECAST" | "TASK_APPROVED" | "START_DATE" | "START_DATE_PROJECT" | "END_DATE" | "END_DATE_PROJECT" | "START_DATE_TIME_REG" | "PHASE_TIME_REG" | "END_DATE_TIME_REG" | "PROJECT_TIME_REG" | "ROLE_TIME_REG" | "TEAM_TIME_REG" | "DEPARTMENT_TIME_REG" | "INTERNAL_TIME_REG" | "TIME_OFF_TIME_REG" | "BILLABLE_TIME_REG" | "NON_PROJECT_TIME_REG" | "NON_PHASE_TIME_REG" | "NON_TASK_TIME_REG" | "NON_CLIENT_TIME_REG" | "NON_DEPARTMENT_TIME_REG" | "NON_ROLE_TIME_REG" | "NON_SPRINT_TIME_REG" | "PERSON_TIME_REG" | "CLIENT_TIME_REG" | "SPRINT_TIME_REG" | "LABEL_TIME_REG" | "TASK_TIME_REG" | "CREATED_AT" | "WITH_TIME_REG" | "WITH_TASKS" | "TASK" | "TASK_LEVEL" | "UPDATED_AT" | "SET_DONE_AT" | "ASSIGNED" | "ASSIGNED_SELF" | "OWNER" | "FOLLOWER" | "LABELS" | "PROJECT_LABELS" | "ROLE" | "PROJECT" | "PROJECT_PERSON" | "CLIENT" | "PROJECT_STAGE" | "PROJECT_STAGE_PROFILE" | "BUG" | "BLOCKED" | "BILLABLE" | "HIGH_PRIORITY" | "STARRED" | "RECENT_TIME" | "RECENT_TASK_ACTIVITY" | "RECENT_ACTIVITY" | "PHASE_CATEGORY" | "SPRINT_CATEGORY" | "DEADLINE" | "OWN_START_DATE" | "OWN_DEADLINE" | "TEAM_MEMBER" | "TEAM" | "PERMISSION_LEVEL" | "CLIENT_GUEST_USERS" | "DEPENDENCIES" | "SUB_TASKS" | "TASK_HIERARCHY" | "DEPARTMENT" | "PERSON" | "NO_CONTACT" | "APPROVAL_STATUS" | "INTERNAL_TIME" | "TIME_OFF" | "PROJECT_FOLLOWER" | "PROJECT_OWNER" | "PROJECT_BUDGET_TYPE" | "PROJECT_DEFAULT_PERIOD_BUDGET_TYPE" | "RATE_CARD" | "CONTACT" | "INVOICED" | "SKILL" | "PRIORITY_LEVEL" | "PROJECT_GROUP" | "PROGRAM" | "FILTER_BY_TIME_REG_SETTINGS" | "BILL_TO" | "BILL_FROM" | "PROJECT_MANUAL_PROGRESS" | "RETAINER_PERIOD" | "PROJECT_WIN_CHANCE" | "CLIENT_CONTACT_CLIENT_ID" | "CLIENT_CONTACT_COMPANY_ID" | "CLIENT_CONTACT_ID" | "CLIENT_CONTACT" | "CLIENT_CONTACT_NAME" | "CLIENT_CONTACT_FIRST_NAME" | "CLIENT_CONTACT_LAST_NAME" | "CLIENT_CONTACT_EMAIL" | "CLIENT_CONTACT_STATUS" | "CLIENT_CONTACT_IS_GUEST_USER" | "PHASE" | "SPRINT" | "DELIVERABLE" | "PARENT" | "PROGRESS" | "ESTIMATE" | "CREATED" | "UPDATED" | "PROJECT_STATUS_RAG" | "PROGRESS_BUCKET" | "WIN_CHANCE_BAND" | "TOTAL_REGISTERED_HOURS" | "BILLABLE_HOURS" | "NON_BILLABLE_HOURS" | "RETAINER_OVER_UNDER" | "RETAINER_PERIOD_START" | "RETAINER_PERIOD_END" | "OVER_ESTIMATE" | "%future added value";
export type GLOBAL_FILTER_LOGICAL_OPERATOR = "AND" | "OR" | "%future added value";
export type GLOBAL_FILTER_OPERATOR = "IS" | "IS_NOT" | "IS_ALL" | "IS_NOT_ALL" | "CONTAINS" | "CONTAINS_NOT" | "GREATER" | "GREATER_OR_EQUAL" | "LESS" | "LESS_OR_EQUAL" | "IN" | "NOT_IN" | "ALL_IN" | "NOT_ALL_IN" | "%future added value";
export type TaskSearchQueryType = {
  filters?: ReadonlyArray<GlobalSearchFilterType | null> | null;
};
export type GlobalSearchFilterType = {
  field?: GLOBAL_FILTER_FIELD | null;
  operator?: GLOBAL_FILTER_OPERATOR | null;
  value?: ReadonlyArray<string | null> | null;
  context?: GLOBAL_FILTER_CONTEXT | null;
  filters?: ReadonlyArray<GlobalSearchFilterType | null> | null;
  logicalOperator?: GLOBAL_FILTER_LOGICAL_OPERATOR | null;
};
export type ConnectedProjectLoader_Query$variables = {
  startYear?: number | null;
  startMonth?: number | null;
  startDay?: number | null;
  endYear?: number | null;
  endMonth?: number | null;
  endDay?: number | null;
  searchQuery: TaskSearchQueryType;
  ignoreBaselineWinChance?: boolean | null;
  excludeOpportunityActuals?: boolean | null;
};
export type ConnectedProjectLoader_Query$data = {
  readonly viewer: {
    readonly actualPersonId: string | null;
    readonly component: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"ConnectedProjectLoader_viewer">;
  } | null;
};
export type ConnectedProjectLoader_Query = {
  variables: ConnectedProjectLoader_Query$variables;
  response: ConnectedProjectLoader_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endDay"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endMonth"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endYear"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "excludeOpportunityActuals"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ignoreBaselineWinChance"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchQuery"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startDay"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startMonth"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startYear"
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "project_portfolio_period_connected_project_loader"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"project_portfolio_period_connected_project_loader\")"
},
v11 = [
  {
    "kind": "Variable",
    "name": "endDay",
    "variableName": "endDay"
  },
  {
    "kind": "Variable",
    "name": "endMonth",
    "variableName": "endMonth"
  },
  {
    "kind": "Variable",
    "name": "endYear",
    "variableName": "endYear"
  },
  {
    "kind": "Variable",
    "name": "excludeOpportunityActuals",
    "variableName": "excludeOpportunityActuals"
  },
  {
    "kind": "Variable",
    "name": "ignoreBaselineWinChance",
    "variableName": "ignoreBaselineWinChance"
  },
  {
    "kind": "Variable",
    "name": "searchQuery",
    "variableName": "searchQuery"
  },
  {
    "kind": "Variable",
    "name": "startDay",
    "variableName": "startDay"
  },
  {
    "kind": "Variable",
    "name": "startMonth",
    "variableName": "startMonth"
  },
  {
    "kind": "Variable",
    "name": "startYear",
    "variableName": "startYear"
  }
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ConnectedProjectLoader_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v9/*: any*/),
          (v10/*: any*/),
          {
            "args": (v11/*: any*/),
            "kind": "FragmentSpread",
            "name": "ConnectedProjectLoader_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v8/*: any*/),
      (v7/*: any*/),
      (v6/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "ConnectedProjectLoader_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v9/*: any*/),
          (v10/*: any*/),
          (v12/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currency",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v11/*: any*/),
                "concreteType": "ProjectGroupTypeConnection",
                "kind": "LinkedField",
                "name": "financialBasedConnectedProjects",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectGroupTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProjectGroupType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v12/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "companyProjectGroupId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "color",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FinancialNumbers",
                            "kind": "LinkedField",
                            "name": "financialNumbers",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "billableActualTimeAndExpenses",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "totalActualRevenueRecognition",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actualCost",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actualRevenueProfit",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actualRevenueMargin",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "billablePlannedTimeAndExpenses",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "plannedRevenue",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "plannedCost",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "plannedRevenueProfit",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "plannedRevenueMargin",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "billableForecastTimeAndExpensesToComplete",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "totalForecastRevenueToComplete",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "forecastCostToComplete",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "forecastRevenueProfitToComplete",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "forecastRevenueMarginToComplete",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "billableTotalTimeAndExpensesAtCompletion",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "nonBillableTotalTimeAndExpensesAtCompletion",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "allTotalTimeAndExpensesAtCompletion",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "totalRevenueRecognition",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "totalCostAtCompletion",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "totalRevenueProfitAtCompletion",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "totalRevenueMarginAtCompletion",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "baselineRevenue",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "baselineTimeAndExpenses",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "baselineCost",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "baselineProfit",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "baselineMargin",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "baselineMinutes",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "planVsBillableActualTimeAndExpenses",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "planVsActualCost",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "planVsActualRevenueProfit",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "planVsActualRevenueRecognition",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "planVsTotalRevenueAtCompletion",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "planVsTotalBillableTimeAndExpensesAtCompletion",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "planVsTotalCostAtCompletion",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "planVsTotalProfitAtCompletion",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "planVsTotalRevenueProfitAtCompletion",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "registeredMinutes",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "forecastTimeToComplete",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "totalTimeAtCompletion",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "totalSuggestedRevenue",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "scopeApprovedMinutes",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "invoiced",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "paid",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "accruedDeferred",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "retainerPeriodTargetMinutes",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "retainerPeriodTargetPrice",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "recognitionLockedRevenue",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "recognitionOpenRevenue",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "programBudgetValue",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "projectedTotalRevenueVsProjectedTotalBillableValueOfService",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "projectedTotalRevenueVsProjectedTotalValueOfService",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "recognitionForecastRevenue",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "85e443fb8c351afc45d1b84e65a4a4e4",
    "id": null,
    "metadata": {},
    "name": "ConnectedProjectLoader_Query",
    "operationKind": "query",
    "text": "query ConnectedProjectLoader_Query(\n  $startYear: Int\n  $startMonth: Int\n  $startDay: Int\n  $endYear: Int\n  $endMonth: Int\n  $endDay: Int\n  $searchQuery: TaskSearchQueryType!\n  $ignoreBaselineWinChance: Boolean\n  $excludeOpportunityActuals: Boolean\n) {\n  viewer {\n    actualPersonId\n    component(name: \"project_portfolio_period_connected_project_loader\")\n    ...ConnectedProjectLoader_viewer_1LGF1c\n    id\n  }\n}\n\nfragment ConnectedProjectLoader_viewer_1LGF1c on Viewer {\n  id\n  company {\n    id\n    currency\n    financialBasedConnectedProjects(searchQuery: $searchQuery, startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, ignoreBaselineWinChance: $ignoreBaselineWinChance, excludeOpportunityActuals: $excludeOpportunityActuals) {\n      edges {\n        node {\n          id\n          name\n          companyProjectGroupId\n          color\n          financialNumbers {\n            ...ProjectPortfolioPeriodRow_financialNumbers\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment ProjectPortfolioPeriodRow_financialNumbers on FinancialNumbers {\n  billableActualTimeAndExpenses\n  totalActualRevenueRecognition\n  actualCost\n  actualRevenueProfit\n  actualRevenueMargin\n  billablePlannedTimeAndExpenses\n  plannedRevenue\n  plannedCost\n  plannedRevenueProfit\n  plannedRevenueMargin\n  billableForecastTimeAndExpensesToComplete\n  totalForecastRevenueToComplete\n  forecastCostToComplete\n  forecastRevenueProfitToComplete\n  forecastRevenueMarginToComplete\n  billableTotalTimeAndExpensesAtCompletion\n  nonBillableTotalTimeAndExpensesAtCompletion\n  allTotalTimeAndExpensesAtCompletion\n  totalRevenueRecognition\n  totalCostAtCompletion\n  totalRevenueProfitAtCompletion\n  totalRevenueMarginAtCompletion\n  baselineRevenue\n  baselineTimeAndExpenses\n  baselineCost\n  baselineProfit\n  baselineMargin\n  baselineMinutes\n  planVsBillableActualTimeAndExpenses\n  planVsActualCost\n  planVsActualRevenueProfit\n  planVsActualRevenueRecognition\n  planVsTotalRevenueAtCompletion\n  planVsTotalBillableTimeAndExpensesAtCompletion\n  planVsTotalCostAtCompletion\n  planVsTotalProfitAtCompletion\n  planVsTotalRevenueProfitAtCompletion\n  registeredMinutes\n  forecastTimeToComplete\n  totalTimeAtCompletion\n  totalSuggestedRevenue\n  scopeApprovedMinutes\n  invoiced\n  paid\n  accruedDeferred\n  retainerPeriodTargetMinutes\n  retainerPeriodTargetPrice\n  recognitionLockedRevenue\n  recognitionOpenRevenue\n  programBudgetValue\n  projectedTotalRevenueVsProjectedTotalBillableValueOfService\n  projectedTotalRevenueVsProjectedTotalValueOfService\n  recognitionForecastRevenue\n}\n"
  }
};
})();

(node as any).hash = "5855cca24ccd606c90c4b761d0dd00ce";

export default node;
